import React from 'react';
import {Button} from 'react-bootstrap';
import AlertListRow from './AlertListRow';
import {formatAmount} from '../../../utils/format';

const AlertList = ({title, data, onViewAll, showDaysOverdue = false}) => {
    const entries = data?.entries ?? [];
    const totalCount = data?.totalCount ?? 0;
    const totalAmount = data?.totalAmount ?? 0;
    const remaining = totalCount - entries.length;

    return (
        <div className="d-flex flex-column h-100">
            <div className="d-flex justify-content-between align-items-baseline mb-2">
                <h5 className="mb-0">{title}</h5>
                <span className="text-muted fw-semibold" style={{fontSize: '0.9rem'}}>
                    {totalCount} {totalCount > 1 ? 'dossiers' : 'dossier'}
                    {totalAmount > 0 ? ` — ${formatAmount(totalAmount)}` : ''}
                </span>
            </div>
            {entries.length === 0 ? (
                <p className="text-muted mb-0">Aucun dossier.</p>
            ) : (
                <div className="flex-grow-1">
                    {entries.map((entry) => (
                        <AlertListRow key={entry.id} entry={entry} showDaysOverdue={showDaysOverdue} />
                    ))}
                </div>
            )}
            {totalCount > 0 && (
                <div className="mt-3 d-flex justify-content-between align-items-center">
                    <Button variant="outline-primary" size="sm" onClick={onViewAll}>
                        Voir tous les dossiers
                    </Button>
                    {remaining > 0 && (
                        <small className="text-muted">+ {remaining} autres</small>
                    )}
                </div>
            )}
        </div>
    );
};

export default AlertList;
